import { render, staticRenderFns } from "./RoleItem.vue?vue&type=template&id=bdbede6c&scoped=true"
import script from "./RoleItem.vue?vue&type=script&lang=js"
export * from "./RoleItem.vue?vue&type=script&lang=js"
import style0 from "./RoleItem.vue?vue&type=style&index=0&id=bdbede6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbede6c",
  null
  
)

export default component.exports